function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTermsCheckChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 40",
    cx: 12,
    cy: 12,
    r: 12,
    style: {
      fill: "#e63d44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.525 7.908a.983.983 0 0 1-.758.325.983.983 0 0 1-.758-.325L.325 4.225a1.047 1.047 0 0 1 0-1.517 1.047 1.047 0 0 1 1.517 0l2.925 2.925L10.075.325a1.047 1.047 0 0 1 1.517 0 1.047 1.047 0 0 1 0 1.517z",
    transform: "translate(6.041 8.208)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTermsCheckChecked);
export default __webpack_public_path__ + "static/media/icon_terms_check_checked.244646231ba324021a88166694366ca0.svg";
export { ForwardRef as ReactComponent };